import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Mail, HandHeart } from "lucide-react";
import { adminContacts, adminJoins } from "@/lib/api";

export default function SubmissionsAdmin() {
  const { data: contacts = [], isLoading: l1 } = useQuery({ queryKey: ["contacts"], queryFn: adminContacts });
  const { data: joins = [], isLoading: l2 } = useQuery({ queryKey: ["joins"], queryFn: adminJoins });

  return (
    <div data-testid="submissions-admin">
      <h1 className="font-display text-2xl md:text-3xl font-semibold text-navy mb-8">Inquiries & Join Requests</h1>

      <div className="grid lg:grid-cols-2 gap-6">
        {/* Contacts */}
        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-200 flex items-center gap-2">
            <Mail className="h-4 w-4 text-civic" />
            <h2 className="font-semibold text-navy">Contact Inquiries ({contacts.length})</h2>
          </div>
          <div className="divide-y divide-slate-100 max-h-[600px] overflow-y-auto">
            {l1 ? <div className="py-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-gold" /></div> :
              contacts.length === 0 ? <p className="px-5 py-10 text-center text-slate-400 text-sm">No inquiries yet.</p> :
              contacts.map((c) => (
                <div key={c.id} className="px-5 py-4">
                  <div className="flex items-center justify-between">
                    <p className="font-medium text-navy">{c.name}</p>
                    <span className="text-xs text-slate-400">{(c.created_at || "").slice(0, 10)}</span>
                  </div>
                  <p className="text-xs text-slate-500 mt-0.5">{c.phone} {c.email && `· ${c.email}`}</p>
                  <p className="text-sm text-slate-600 mt-2">{c.message}</p>
                </div>
              ))}
          </div>
        </div>

        {/* Joins */}
        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-200 flex items-center gap-2">
            <HandHeart className="h-4 w-4 text-gold" />
            <h2 className="font-semibold text-navy">Join the Movement ({joins.length})</h2>
          </div>
          <div className="divide-y divide-slate-100 max-h-[600px] overflow-y-auto">
            {l2 ? <div className="py-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-gold" /></div> :
              joins.length === 0 ? <p className="px-5 py-10 text-center text-slate-400 text-sm">No requests yet.</p> :
              joins.map((j) => (
                <div key={j.id} className="px-5 py-4">
                  <div className="flex items-center justify-between">
                    <p className="font-medium text-navy">{j.name}</p>
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-gold/15 text-gold">{j.interest}</span>
                  </div>
                  <p className="text-xs text-slate-500 mt-0.5">{j.phone} {j.locality && `· ${j.locality}`}</p>
                  {j.message && <p className="text-sm text-slate-600 mt-2">{j.message}</p>}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
